import Api from '../../app/services/api';

const deleteUser = (id) => Api.delete(`/user/${id}`);

const getUser = (id) => Api.get(`/user/${id}`);

const getUsers = (params) => Api.get('/user', params);

const saveUser = (params) => Api.post('/user', params);

export {
  getUser,
  getUsers,
  deleteUser,
  saveUser,
};
